var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFacebookinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.222 0h15.556C19.006 0 20 1.06 20 2.37v16.59c0 1.309-.994 2.37-2.222 2.37H2.222C.994 21.33 0 20.268 0 18.96V2.37C0 1.06.994 0 2.222 0zm14.444 2.368h-2.778c-2.148 0-3.89 1.855-3.89 4.147v2.962H7.778v3.555h2.222v8.295h3.333v-8.295h3.334V9.477h-3.334v-2.37c0-.655.498-1.185 1.111-1.185h2.223V2.368z",
    fill: "#fff"
  })));
}

export default SvgFacebookinline;